import { Card, Spin, Table } from "antd";
import moment from "moment";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";
import { UseApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-api-call";
import { useCurrentUserContext } from "providers";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { MONTHS } from "utils/constants";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (text, record, index) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
  },
  {
    title: "Order ID",
    dataIndex: "PaymentId",
    key: "PaymentId",
    render: (state) => "#" + state,
  },
  {
    title: "Start Date",
    dataIndex: "StartDate",
    key: "StartDate",
    render: (state) => moment(state).format("LL"),
  },
  {
    title: "End Date",
    dataIndex: "EndDate",
    key: "EndDate",
    render: (state) => moment(state).format("LL"),
  },
  {
    title: "Amount",
    dataIndex: "Amount",
    key: "Amount",
    render: (state) => "€" + state,
  },
  {
    title: "Validity",
    dataIndex: "Plan",
    key: "Plan",
  },
  {
    title: "Status",
    dataIndex: "Status",
    render: (text) => <span style={{ color: "green" }}>{text}</span>,
  },
];
const dummyColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: "5%",
    render: (text, record, index) => {
      return index < 9 ? `0${index + 1}` : index + 1;
    },
  },
  {
    title: "Order ID",
    dataIndex: "id",
    key: "id",
    width: "7%",
    render: (state) => "#" + state,
  },

  {
    title: "Subscription",
    dataIndex: "subscription_name",
    key: "subscription_name",
    width: "10%",
  },
  {
    title: "Platform",
    dataIndex: "platform_name",
    key: "platform_name",
    width: "7%",
    render: (state) =>
      state && JSON.parse(state?.replace(/'/g, '"'))?.join(", "),
  },
  {
    title: "Duration",
    dataIndex: "subscription_name",
    key: "subscription_name",
    width: "12%",
  },
  {
    title: "Start Date",
    dataIndex: "createdAt",
    key: "createdAt",
    width: "12%",
    render: (state) => (state ? moment(state).format("LL") : ""),
  },
  {
    title: "End Date",
    dataIndex: "endDate",
    key: "endDate",
    width: "12%",
    render: (state) => (state ? moment(state).format("LL") : ""),
  },
  {
    title: "Extended By",
    dataIndex: "payment_method",
    key: "payment_method",
    width: "12%",
    render: (state, row) => {
      const isUser = row.environment !== "dashboard";
      const colors = getColors(row);
      return (
        <div
          style={{
            backgroundColor: colors.bgColor,
            borderRadius: "28px",
            width: "fit-content",
            padding: "4px 8px",
            boxSizing: "border-box",
            color: colors.textColor,
          }}
        >
          <span
            style={{
              height: "8px",
              width: "8px",
              backgroundColor: colors.dotColor,
              borderRadius: "50%",
              display: "inline-block",
              marginRight: "2px",
            }}
          />
          {isUser ? "User" : `Fenris-${state?.split(" ")[0]}`}
        </div>
      );
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: "7%",
    render: (state) => `€${state}`,
  },
];
const dummyData = [
  {
    key: "1",
    id: "01",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "User",
    Duration: "6 Months",
  },
  {
    key: "2",
    id: "02",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "Fenris-Dirk",
    Duration: "6 Months",
  },
  {
    key: "3",
    id: "03",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "User",
    Duration: "6 Months",
  },
  {
    key: "4",
    id: "04",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "User",
    Duration: "6 Months",
  },
  {
    key: "5",
    id: "05",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "User",
    Duration: "6 Months",
  },
  {
    key: "6",
    id: "06",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "User",
    Duration: "6 Months",
  },
  {
    key: "7",
    id: "07",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "User",
    Duration: "6 Months",
  },
  {
    key: "8",
    id: "08",
    PaymentId: "#98765",
    StartDate: "Mar 01, 2024",
    EndDate: "Mar 01, 2024 ",
    Amount: "€300",
    Validity: "3 months",
    Status: "Success",
    Subscription: "Premium",
    Platform: "Studio",
    ExtendedBy: "User",
    Duration: "6 Months",
  },
];
const notUser = {
  textColor: "black",
  bgColor: "#38476D17",
  dotColor: "black",
};
const user = {
  textColor: "#1E9609",
  bgColor: "#A5FF9647",
  dotColor: "#1E9609",
};

function getColors(row) {
  const isUser = row.environment !== "dashboard";

  return isUser ? user : notUser;
}

export const SubscriptionHistoryTable = ({ loading, subscriptionHistory }) => {
  return (
    <div className={styles.subscriptionHistory}>
      <Table
        pagination={false}
        // columns={columns}
        columns={dummyColumns}
        className={styles.userListTable}
        scroll={{
          y: 170,
        }}
        components={{
          body: {
            wrapper: (props) => {
              const { className, style, ...restProps } = props;
              return <tbody style={{ ...style }} {...restProps} />;
            },
          },
        }}
        dataSource={subscriptionHistory?.subscriptions?.reverse()}
        // dataSource={dummyData}
      />
    </div>
  );
};
